import {
  Component,
  OnInit,
  AfterViewInit,
  HostListener,
  ElementRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { RecommendationService } from '../recommendation/recommendation.service';
import { _ } from 'underscore';
import { Router } from '@angular/router';
import { ResidentialService } from '../residential.service';
import { UserSettingsService } from '../../../user-settings/user-settings.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { PlatformLocation } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import * as Highcharts from 'highcharts';
Highcharts.setOptions({ lang: { thousandsSep: ',' } });

@Component({
  selector: 'app-energyplan-confirmation',
  templateUrl: './energyplan-confirmation.component.html',
  styleUrls: ['./energyplan-confirmation.component.css'],
})
export class EnergyplanConfirmationComponent implements OnInit, AfterViewInit {
  selectedProduct;
  t1_avg_charge;
  t2_avg_charge;
  t3_avg_charge;
  avgMthlyUsage;
  averagePrice;
  avgbill;
  Math: any;
  math = Math;
  // API url
  url = environment.api_url;
  modalRef: BsModalRef;
  @ViewChild('newEnergyRates', { static: true }) newEnergyRates: ElementRef;
  private loadEnergyProviders = {
    ProntoPower: this.navigatePrePaidEnergyProvider.bind(this),
    PulsePower: this.navigateOtherEnergyProviders.bind(this),
    NewPowerTexas: this.navigateOtherEnergyProviders.bind(this),
    ChariotEnergy: this.navigateOtherEnergyProviders.bind(this),
    Bulb: this.navigateBulbEnergyProvider.bind(this),
    ChangeEnergy4: this.navigateOtherEnergyProviders.bind(this),
    GexaEnergy: this.navigateOtherEnergyProviders.bind(this),
    FrontierUtilities: this.navigateOtherEnergyProviders.bind(this),
    TexpoEnergy: this.navigateOtherEnergyProviders.bind(this),
    RhythmEnergy: this.navigateOtherEnergyProviders.bind(this),
    BKVEnergy: this.navigateOtherEnergyProviders.bind(this),
    APGEEnergy: this.navigateOtherEnergyProviders.bind(this),
    ShellEnergy: this.navigateOtherEnergyProviders.bind(this),
  };
  showFilters = false;
  isMobileView = false;
  usageTier: any;
  private loadEnergyProvidersImages = {
    NewPowerTexas: 'assets/images/NewPowerTexas-minlogo.jpg',
    PulsePower: 'assets/images/PulsePower-minlogo.jpg',
    ChariotEnergy: 'assets/images/chariot-minlogo.png',
    GexaEnergy: 'assets/images/Gexa_minlogo.png',
    FrontierUtilities: 'assets/images/Frontier_Utilities_minlogo.png',
    ChangeEnergy4CE: 'assets/images/4change_energy_minlogo.png',
    Bulb: 'assets/images/Bulb_minlogo.png',
    ProntoPower: 'assets/images/ProntoPower_minLogo.png',
    TexpoEnergy: 'assets/images/TexpoEnergy_minLogo.png',
    RhythmEnergy: 'assets/images/RhythmEnergy_minLogo.png',
    BKVEnergy: 'assets/images/bkv-minlogo.png',
    APGEEnergy: 'assets/images/apg-minlogo.jpg',
    ShellEnergy: 'assets/images/shell-minlogo.png'
  };
  showAll: boolean;
  productKeyTitle: string;
  productTitle: any;
  avgCharge500: string;
  avgCharge1000: string;
  avgCharge2000: string;
  recommendedEnergyCharge: any;
  recommendedBaseFee: any;
  recommendedBaseUsageLimit: any;
  recommendedTduCharge: string;
  recommendedTduDeliveryCharge: any;
  averageMonthlyUsage: any;
  avgPricePerKWH: string;
  avgMonthlyBill: any;
  recommendedUsageCreditFee: any;
  recommendedUsageCreditLimit: string;
  monthlyEstimates: string[];
  toggleHighcharts: boolean;
  graphSelectedProduct: any;
  productIndex: number;
  recommendations: any;
  monthlyUsageArr: any;
  avg_price_kwh: any;
  oldValue: any;
  showOption: any;
  updateProductChart = false;
  newValue: any;
  selectedIndex: number;
  monthName: any;
  updatedNewValue: any;
  updateValue: boolean;
  pointWidth: any;
  graaphLabelName: any;
  visibleGraph: any;
  Highcharts = Highcharts;
  highChartsOptions;
  DELAY = 700;
  clicks = 0;
  timer = null;
  showDetal = false;
  recommendationObj: any;
  deviceWidth;
  singleObj: any;
  // To handle the page close or reload event - After questionnarie
   @HostListener('window:beforeunload', ['$event'])
   beforeunloadHandler($event) {
     $event.returnValue = false;
     const questionObj = {
       questionStatus: 'Completed',
       questionStep: this.residentialService.currentId,
       type: this.residentialService.service,
       percentage: 100,
       enrollmentState: 'Quitted',
     };
     sessionStorage.setItem('questionStatusObj', JSON.stringify(questionObj));
     setTimeout(() => {
       return this.residentialService.quitFlow();
     }, 50);
     // }
   }

  constructor(
    private recommendationService: RecommendationService,
    private router: Router,
    private residentialService: ResidentialService,
    private userSettingsService: UserSettingsService,
    private http: HttpClient,
    private location: PlatformLocation,
    private modalService: BsModalService,
    private _renderer2: Renderer2,
  ) {}

  ngOnInit() {
    this.loadScript();
    this.assignSelectedSignupProduct();
    this.saveRecommendedSelectedProduct();
    this.t1_avg_charge = (
      Number(this.selectedProduct.tier[0].avg_charge) * 100
    ).toFixed(1);
    this.t2_avg_charge = (
      Number(this.selectedProduct.tier[1].avg_charge) * 100
    ).toFixed(1);
    this.t3_avg_charge = (
      Number(this.selectedProduct.tier[2].avg_charge) * 100
    ).toFixed(1);
    this.avgMthlyUsage = Math.round(
      this.selectedProduct.new_tier.ave_monthly_usage
    );
    this.averagePrice =
      Number(this.selectedProduct.new_tier.ave_price_per_KWH) * 100;
    this.avgbill = Math.round(this.selectedProduct.new_tier.ave_monthly_bill);
    var entered = true;
    this.location.onPopState(() => {
        //history.forward();
        if(entered)
        {
          setTimeout(function(){   this.back();},100)
       
          entered = false;
        }
       
    });
    this.changeIUsageGraphbyProduct(this.selectedProduct);
    // this.inializeFn();

    this.deviceWidth = window.innerWidth;
    if (this.deviceWidth > 768) {
    } else {
      this.isMobileView = true;
      $($("body").find('div')[0]).addClass('Headermargin2')
    }

    //  var id = this.recommendationService.hg_accountId;
     // var isMobileView = this.isMobileView;
      // $(window).on('popstate', function (event) {

      //     if (isMobileView == true) {

      //        // location.href = '/recommendation/compare-product/' + id;
        
      //         // this.location.pushState("forward",null,"/recommendation/compare-product"+
      //         // this.recommendationService.hg_accountId)

      //     }


      // });



  }

  changeIUsageGraphbyProduct(productObj) {
    sessionStorage.setItem(
      'recommendationsSelected',
      JSON.stringify(this.residentialService.recommendations)
    );
    try{
      var index = this.residentialService.recommendations.findIndex(
        (x) => x.ProductID === productObj.ProductID
      );
      this.graaphLabelName = this.assignEnergyProvidersLabelName(index);

    }catch{

    }

    // this.onfreeze();
    // this.changeIUsageGraph(this.recommendations[index], index);
    this.inializeFn();
  }

  assignEnergyProvidersLabelName(i): any {
    return `${
      this.residentialService.recommendations[i].terms
    } ${this.residentialService.recommendations[
      i
    ].energy_provider.toUpperCase()}-${this.residentialService.recommendations[
      i
    ].product_key.toUpperCase()}`;
  }

  assignSelectedSignupProduct() {
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.recommendationService.signupProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
  }

  ngAfterViewInit(): void {
    const avgElements = document.getElementsByClassName('avgvalue');
    for (let i = 0; i < avgElements.length; i++) {
      if (avgElements[i].classList.contains('avgvalue')) {
        if (this.averagePrice.length >= 11 || this.avgbill.length >= 11) {
          avgElements[i].classList.add('avgpricelen32');
        } else if (
          this.averagePrice.length === 10 ||
          this.avgbill.length === 10
        ) {
          avgElements[i].classList.add('avgpricelen37');
        } else if (
          this.averagePrice.length === 9 ||
          this.avgbill.length === 9
        ) {
          avgElements[i].classList.add('avgpricelen42');
        } else if (
          this.averagePrice.length === 8 ||
          this.avgbill.length === 8
        ) {
          avgElements[i].classList.add('avgpricelen46');
        } else if (
          this.averagePrice.length === 7 ||
          this.avgbill.length === 7
        ) {
          avgElements[i].classList.add('avgpricelen50');
        } else if (this.averagePrice.length <= 6 || this.avgbill.length <= 6) {
          avgElements[i].classList.add('mobavgpricelen32');
        }
      }
    }
  }

  back() {
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  saveRecommendedSelectedProduct() {
    sessionStorage.setItem('noUserId', this.recommendationService.hg_accountId);
    const hgAccountId = {
      hg_accountId: this.recommendationService.hg_accountId,
      userResponses: JSON.parse(sessionStorage.getItem('userResponse')),
    };
    this.residentialService
      .postSelectedProductAPI({
        ...this.recommendationService.signupProduct,
        ...hgAccountId,
      })
      .subscribe((res: any) => {});
  }

  next() {

    // var user = {
    //   "_id": "630263ecc136af6d90660307",
    //   "accountType": "internal",
    //   "fName": "",
    //   "lName": "",
    //   "emailId": "",
    //   "questionStatusObj": {
    //     "questionStatus": "Quitted",
    //     "questionStep": "002",
    //     "type": "",
    //     "property": "",
    //     "percentage": null
    //   },
    //   "password": "",
    //   "phone": "",
    //   "userName": "",
    //   "numFailures": 0,
    //   "isEnabled": "Y",
    //   "createdDate": "",
    //   "lastUpdatedDate": "",
    //   "createdBy": "0",
    //   "lastUpdatedBy": "0",
    //   "initialEmail": "",
    //   "oldEmail": "",
    //   "oldPassword": "",
    //   "oldPhoneNumber": ""
    // }

    //sessionStorage.setItem('userObj', JSON.stringify(user));

    const accountId = this.recommendationService.hg_accountId = '630263ecc136af6d90660307';
    // this.residentialService.validateHGAccountID(accountId)
    //   ? this.submitOrderProductDetails()
    //   : this.getUserDetails();

    this.submitOrderProductDetails()
  }

  submitOrderProductDetails() {
    const energyProviderName =
        this.recommendationService.signupProduct.energy_provider,
      utilityName = this.recommendationService.signupProduct.utility_name,
      planName = this.recommendationService.signupProduct.product_key,
      productID = this.recommendationService.signupProduct.ProductID;

    this.residentialService
      .getEnergyProvidersPlanStatus(energyProviderName, utilityName, planName)
      .subscribe(
        (res: any) => {
          this.checkEnergyProvidersApiPlanStatus(res, productID);
        },
        (err) => {
          this.getUserDetails();
        }
      );
  }

  checkEnergyProvidersApiPlanStatus(res, productID) {
    if (
      res.length > 0 &&
      productID !== res[0].ProductID &&
      this.residentialService.validateCreatedDateTime(res[0].createdDate)
    ) {
      this.assignNewEnergyProvidersRates();
    } else {
      this.getUserDetails();
    }
  }

  assignNewEnergyProvidersRates() {
    const user = {
      esiid: null,
      questionStatusObj: sessionStorage.getItem('questionStatusObj'),
      questionnarieObj: JSON.parse(sessionStorage.getItem('userResponse')),
    };
    this.residentialService.getRecommendations(user).subscribe((result) => {
      this.recommendationService.recommendationObj =
        result['recommendedProduct'];
      sessionStorage.setItem(
        'recommendedProducts',
        JSON.stringify(result['recommendedProduct'])
      );
      this.openNewEnergyRatesModal(this.newEnergyRates);
    });
  }

  openNewEnergyRatesModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  newEnergyProviderRates() {
    sessionStorage.setItem(
      'currentUser',
      this.recommendationService.hg_accountId
    );
    this.modalRef.hide();
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  getUserDetails() {
    const hg_accountId = window.location.href.split('/').pop(),
      body = new HttpParams().append('hg_accountId', this.recommendationService.hg_accountId);
    this.http
      .get(this.url + '/getHgUser', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (!_.isEmpty(result)) {
          this.residentialService.user = result.user
            ? result.user
            : this.residentialService.user;
        }
        if (
          this.residentialService.user &&
          //this.residentialService.user.emailId &&
          (!_.isEmpty(this.residentialService.user.accountId) ||
            !_.isEmpty(this.residentialService.user._id))
        ) {
          this.validateNewEnergyProvider();
        } else {
          sessionStorage.setItem('zipCode', this.residentialService.zipCode);
          this.router.navigate(['signup']);
        }
      });
  }

  validateNewEnergyProvider() {
    if (this.residentialService.user) {
      this.loadEnergyProviders[
        this.recommendationService.signupProduct.energy_provider ===
        '4Change Energy'
          ? `${this.recommendationService.signupProduct.energy_provider
              .replace(/\s/g, '')
              .slice(1)}4`
          : this.recommendationService.signupProduct.energy_provider.replace(
              /\s/g,
              ''
            )
      ]();
    }
  }

  navigateBulbEnergyProvider() {
    window.location.href = `https://join.bulb.com/?utm_source=HonestGorilla&utm_medium=pcw&utm_campaign=HonestGorilla`;
  }

  navigatePrePaidEnergyProvider() {
    this.router.navigate([
      'prepaidoption',
      this.recommendationService.hg_accountId,
    ]);
  }

  navigateOtherEnergyProviders() {
    this.router.navigate([
      'signuporder',
      this.recommendationService.hg_accountId,
    ]);
  }

  showFilterCard(selectedProduct) {
    this.showFilters = !this.showFilters;
    this.usageTier = this.selectedProduct.tier;
    this.openDialog(selectedProduct);
  }

  getImagesPerEnergyProviders(itemName) {
    return this.loadEnergyProvidersImages[
      this.actualEnergyProviderName(itemName)
    ];
  }

  actualEnergyProviderName(itemName) {
    return itemName === '4Change Energy'
      ? 'ChangeEnergy4CE'
      : itemName.replace(/\s/g, '');
  }

  openDialog(singleObj) {
    this.showAll = !this.showAll;
    this.openPlanDetails(singleObj);
  }

  openPlanDetails(singleObj) {
    this.singleObj = singleObj;
    this.productKeyTitle = `${singleObj.energy_provider} - ${singleObj.product_key}`;
    this.productTitle = singleObj.energy_provider;
    this.avgCharge500 = Number(singleObj.tier[0].avg_charge * 100).toFixed(1);
    this.avgCharge1000 = (singleObj.tier[1].avg_charge * 100).toFixed(1);
    this.avgCharge2000 = (singleObj.tier[2].avg_charge * 100).toFixed(1);
    this.recommendedEnergyCharge = singleObj.energy_charge;
    this.recommendedBaseFee =
      singleObj.base_fee !== null &&  singleObj.base_fee != undefined
        ? singleObj.base_fee > 0
          ? singleObj.base_fee
          : singleObj.base_fee.toString().substring(1)
        : 0;
    //this.recommendedBaseFee =
    // this.recommendedBaseFee < 0
    //   ? `-$${this.recommendedBaseFee}`
    //   : this.recommendedBaseFee;
    if (singleObj.base_fee_limit) {
      this.recommendedBaseUsageLimit =
        singleObj.base_fee_limit.search('undefined') > 0
          ? `>=${singleObj.base_fee_limit.substring(
              0,
              singleObj.base_fee_limit.indexOf('undefined') - 1
            )}`
          : singleObj.base_fee_limit;
      this.recommendedBaseUsageLimit = ` for usage ${this.recommendedBaseUsageLimit} kWh`;
    }

    this.recommendedTduCharge = Number(singleObj.tdu_delivery_charge).toFixed(
      2
    );
    this.recommendedTduDeliveryCharge = singleObj.tdu_delivery_charge_per_kwh;
    this.averageMonthlyUsage = Math.floor(singleObj.new_tier.ave_monthly_usage);
    this.avgPricePerKWH = Number(
      singleObj.new_tier.ave_price_per_KWH * 100
    ).toFixed(1);
    this.avgMonthlyBill = Number(singleObj.new_tier.ave_monthly_bill).toFixed(2);
    this.recommendedUsageCreditFee =
      singleObj.usage1Charge !== undefined ? singleObj.usage1Charge : 0;
    this.recommendedUsageCreditLimit = `${singleObj.usage1} - ${singleObj.usage2}`;
    this.monthlyEstimates = [
      Number(
        Number(singleObj.energy_charge * 500) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh * 500)
      ).toFixed(2),
      Number(
        Number(singleObj.energy_charge * 1000) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh * 1000)
      ).toFixed(2),
      Number(
        Number(singleObj.energy_charge * 2000) +
          Number(singleObj.tdu_delivery_charge) +
          Number(singleObj.tdu_delivery_charge_per_kwh) * 2000
      ).toFixed(2),
    ];
  }

  showHighcharts() {
    this.toggleHighcharts = !this.toggleHighcharts;
  }

  inializeFn() {
    // for average amount change below gaph
    this.graphSelectedProduct = this.selectedProduct;
    this.avgMthlyUsage = Math.round(
      this.selectedProduct.new_tier.ave_monthly_usage
    );
    this.recommendationObj = JSON.parse(
      sessionStorage.getItem('recommendedProducts')
    );
    // For graph reset value and initial value -> while opening the edit
    this.monthlyUsageArr = this.recommendationObj.current_usage;
    if (this.avg_price_kwh != undefined) {
      let splitdata = this.avg_price_kwh.split('.');
      this.avg_price_kwh = splitdata[1];
    }
    // set that value in local storage to reset
    sessionStorage.setItem(
      'monthlyUsage_recommendation',
      JSON.stringify(this.recommendationObj)
    );

    // To get the old value
    this.oldValue = this.recommendationObj.current_usage.map(function (
      value,
      key
    ) {
      return {
        point: value.month,
        color: 'rgba(206,206,206,0.5)',
        avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
        y: Number(value.avg_energy_charge_per_KWH) * Number(value.usage),
        usage: Number(value.usage),
      };
    });

    // To change the color if the edit option is enabled
    let color = '#ffc214';
    if (this.showOption) {
      color = 'rgba(255, 194, 20,0.5)';
    }
    // recommended values
    if (this.updateProductChart === false) {
      this.newValue =
        this.recommendationObj.res_products_recommendations[0].monthly_usage.map(
          (value, key) => {
            return {
              point: value.month,
              color: color,
              avg_energy_charge_per_KWH: value.avg_energy_charge_per_KWH,
              y: value.avg_energy_charge_per_KWH,
              energy_charge_per_month: value.total_energy_charge_per_month
                ? value.total_energy_charge_per_month
                : 0,
              usage: value.usage,
            };
          }
        );
      for (let i = 0; i < this.oldValue.length; i++) {
        for (let j = 0; j < this.newValue.length; j++) {
          if (this.oldValue[i].point === this.newValue[j].point) {
            this.newValue[j].y = Math.round(
              Number(this.newValue[j].y) * Number(this.oldValue[i].usage)
            );
            // To change the selected bar color if it is in edit mode
            if (this.showOption && this.selectedIndex === j) {
              this.newValue[j].color = '#ffc214';
            }
          }
        }
      }
    } else {
      for (let i = 0; i < this.oldValue.length; i++) {
        for (let j = 0; j < this.newValue.length; j++) {
          if (this.oldValue[i].point === this.newValue[j].point) {
            this.newValue[j].y = Math.round(
              Number(this.newValue[j].energy_charge_per_month)
            );
            // To change the selected bar color if it is in edit mode
            if (this.showOption && this.selectedIndex === j) {
              this.newValue[j].color = '#ffc214';
            }
          }
        }
      }
    }
    this.loadHighChart();
  }

  // To load the highchart
  loadHighChart() {
    const self = this;
    // Left side highchart
    this.highChartsOptions = {
      chart: {
        renderTo: 'container',
        type: 'column',
        marginTop: 60,
      },
      xAxis: {
        categories: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        labels: {
          formatter: function (event) {
            // To show the total_energy_charge_per_month below month label in x-axis
            const series2Val = !_.isEmpty(self.visibleGraph)
              ? self.visibleGraph
              : self.highChartsOptions.series[1]
              ? self.highChartsOptions.series[1]
              : self.highChartsOptions.series[0];
            return (
              event.value +
              '<br>' +
              '$' +
              (!_.isEmpty(series2Val)
                ? Math.round(series2Val.data[event.pos].energy_charge_per_month)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
                  '<br>' +
                  (self.highChartsOptions.series[1] != undefined
                    ? (
                        self.highChartsOptions.series[1].data[event.pos]
                          .avg_energy_charge_per_KWH * 100
                      ).toFixed(1) + '¢'
                    : (
                        self.highChartsOptions.series[0].data[event.pos]
                          .avg_energy_charge_per_KWH * 100
                      ).toFixed(1) + '¢')
                : Math.round(
                    self.highChartsOptions.series[0].data[event.pos]
                      .energy_charge_per_month
                  )
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            );
          },
          autoRotation: false,
          style: {
            'font-family': 'Calibre',
            'font-size': '13px',
          },
        },
      },
      yAxis: {
        title: false,
        labels: {
          overflow: 'justify',
          enabled: false,
        },
        gridLineWidth: 0,
      },
      plotOptions: {
        series: {
          // colorByPoint: true,
          cursor: 'pointer',
          point: {
            events: {
              click: function (event) {
                self.clicks++; // count clicks
                if (self.clicks === 1) {
                  self.timer = setTimeout(function () {
                    self.clicks = 0; // after action performed, reset counter
                    if (
                      self.selectedIndex !== event.point.index &&
                      event.point.color === 'rgba(255, 194, 20,0.5)'
                    ) {
                      self.updateChart(event);
                    } else {
                      self.clicks = 0; // after action performed, reset counter
                    }
                  }, self.DELAY);
                } else {
                  clearTimeout(self.timer); // prevent single-click action
                  // To reset the color for already selected bar
                  if (!_.isEmpty(self.highChartsOptions.series[1])) {
                    self.highChartsOptions.series[1].data[
                      self.selectedIndex
                    ].color = 'rgba(255, 194, 20,0.5)';
                  } else {
                    self.highChartsOptions.series[0].data[
                      self.selectedIndex
                    ].color = 'rgba(255, 194, 20,0.5)';
                  }
                  // Changing the current Index as selected index
                  self.selectedIndex = event.point.index;
                  self.monthName = event.point.point;

                  // Calculating the updatedNewValue if the monthly usage is changed
                  self.updatedNewValue =
                    self.oldValue[self.selectedIndex].usage;

                  // To check the value is changed or not
                  document.getElementById('editValue')['value'] =
                    self.updatedNewValue;
                  const elem =
                    document.getElementsByClassName('highcharts-tooltip');
                  const tooltipElem =
                    document.getElementsByClassName('updatept');
                  tooltipElem[0]['style'].top = elem[1]['style'].top;
                  tooltipElem[0]['style'].left = elem[1]['style'].left;

                  if (!_.isEmpty(self.highChartsOptions.series[1])) {
                    self.highChartsOptions.series[1].data[
                      self.selectedIndex
                    ].color = '#ffc214';
                  } else {
                    self.highChartsOptions.series[0].data[
                      self.selectedIndex
                    ].color = '#ffc214';
                  }
                  self.updateValue = true;
                  self.clicks = 0; // after action performed, reset counter
                }
              },
            },
          },
          pointWidth: self.pointWidth,
          events: {
            legendItemClick: function (e) {
              const visibility = this.visible ? 'visible' : 'hidden';
              if (_.isEmpty(self.highChartsOptions.series[1])) {
                // new service -> so restrict the click action
                e.preventDefault();
              } else {
                const chart = this.chart;
                const index = this.index;
                let atleastOneVisible = false;
                // assign the visible graph to change the x-axis label on legend click
                $.each(chart.series, function (i, serie) {
                  if (serie.visible && serie.index !== index) {
                    atleastOneVisible = true;
                    self.visibleGraph =
                      self.highChartsOptions.series[serie.index];
                  }
                });
                // if both are visible then choose the new value

                if (
                  atleastOneVisible &&
                  ((chart.series[0].visible === false &&
                    chart.series[1].visible === true) ||
                    (chart.series[1].visible === false &&
                      chart.series[0].visible === true))
                ) {
                  self.visibleGraph = self.highChartsOptions.series[1];
                } else {
                  // before this code is not written here . --siva j
                  self.visibleGraph = self.highChartsOptions.series[0];
                }
                // to show atleast one legend
                if (!atleastOneVisible) {
                  e.preventDefault();
                } else {
                  self.updateValue = true;
                }
              }
            },
          },
        },
        column: {
          pointWidth: 20,
          groupPadding: 0.5,
        },
      },
      tooltip: {
        style: {
          pointerEvents: 'all',
        },
        useHTML: true,
        formatter: function (event) {
          // To show the tooltip with current usage value
          let tooltipHTML = this.x;
          const series2Val = self.highChartsOptions.series[1];
          if (!_.isEmpty(series2Val)) {
            tooltipHTML =
              '<div class="chart_tool_tip">' +
              this.x +
              '<span class="d-block">' +
              Math.round(
                self.highChartsOptions.series[0].data[this.point.index].usage
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
              '</span>' +
              '</div>';
            return tooltipHTML;
          } else {
            tooltipHTML =
              '<div class="chart_tool_tip">' +
              this.x +
              '<span class="d-block">' +
              Math.round(self.oldValue[this.point.index].usage)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
              '</span>' +
              '</div>';
            return tooltipHTML;
          }
        },
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        verticalAlign: 'top',
        floating: true,
        x: 0,
        y: 0,
        backgroundColor: '#FFFFFF',
        shadow: false,
        useHTML: true,
        margin: 100,
        itemDistance: 50,
        itemMarginTop: 5,
        itemMarginBottom: 5,
        itemStyle: {
          color: '#000000',
          fontWeight: 'normal',
          fontSize: '14px',
          fontFamily: 'Calibre',
        },
        symbolRadius: 0,
        labelFormatter: function (event) {
          return this.name;
        },
      },
      lang: { thousandsSep: ',' },
      series: [
        {
          name: this.graaphLabelName
            ? this.graaphLabelName
            : 'New 12 Months Rate',
          data: this.newValue,
          color: '#ffc214',
        },
      ],
    };
    // To check 'New Service' and 'Switching providers'
    if (this.recommendationObj.service_type !== 'Switching Providers') {
      this.highChartsOptions.series = [
        {
          name: this.graaphLabelName
            ? this.graaphLabelName
            : 'New 12 Months Rate',
          data: this.newValue,
          color: '#ffc214',
        },
      ];
      // to disable the legend hover
      this.highChartsOptions.legend.itemStyle = {
        color: '#000000',
        fontWeight: 'normal',
        fontSize: '14px',
        fontFamily: 'Calibre',
        cursor: 'default',
      };
      this.updateValue = true;
    }
    if (window.screen.availWidth < 595) {
      this.highChartsOptions.plotOptions.series.pointWidth = 22;
    } else {
      this.highChartsOptions.plotOptions.series.pointWidth = 35;
    }
  }
  updateChart(event) {
    const value = Number(this.updatedNewValue);
    let updatedMonth;

    // Check the type and assign the data value
    if (!_.isEmpty(this.highChartsOptions.series[1])) {
      this.highChartsOptions.series[1].data[this.selectedIndex].y =
        value *
        Number(
          this.highChartsOptions.series[1].data[this.selectedIndex]
            .avg_energy_charge_per_KWH
        );
      this.highChartsOptions.series[1].data[this.selectedIndex].color =
        '#ffc214';
      updatedMonth =
        this.highChartsOptions.series[1].data[this.selectedIndex].point;
    } else {
      this.highChartsOptions.series[0].data[this.selectedIndex].y =
        value *
        Number(
          this.highChartsOptions.series[0].data[this.selectedIndex]
            .avg_energy_charge_per_KWH
        );
      this.highChartsOptions.series[0].data[this.selectedIndex].color =
        '#ffc214';
      updatedMonth =
        this.highChartsOptions.series[0].data[this.selectedIndex].point;
    }
  }
  setCancellationText(itemValue) {
    return itemValue == null
      ? '$0. There is no cancellation fee associated with this product. You may cancel at any time free of charge. '
      : itemValue.toString().length > 2
      ? `$${itemValue} Note: this fee will not apply if you move and provide a forwarding address verifying the move.`
      : `$${itemValue} per month remaining on contract. Note: this fee will not apply if you move and provide a forwarding address verifying the move.`;
  }
  setValidatedValue(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? Number(itemValue).toFixed(2)
            : itemValue
        }`;
  }
  setValidatedValue_Pulse(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? Number(itemValue).toFixed(3)
            : itemValue
        }`;
  }
  setValidatedValue_4Change(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? Number(itemValue).toFixed(5)
            : Number(itemValue).toFixed(5)
        }`;
  }
  setValidatedValue_Rhythm(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
            ? Number(itemValue).toFixed(5)
            : Number(itemValue).toFixed(5)
        }`;
  }
  setValidatedTDUValue(itemValue) {
    return itemValue === undefined
      ? ''
      : itemValue < 0
      ? `-$${itemValue.toString().substr(1)}`
      : `$${
          typeof itemValue === 'string'
          ? parseFloat(itemValue).toFixed(6)
          : itemValue.toFixed(6)
        }`;
  }
  SetBaseChargeValidatedValue(itemValue) {
    return typeof Number(itemValue) === 'number' ? Number(itemValue).toString() == "NaN" ? '$0.00'  : `$${itemValue}` : '$0.00';
  }
  setBaseChargeValue(itemValue) {
    return itemValue.energy_provider === 'Pulse Power' ||
      itemValue.energy_provider === 'New Power Texas'
      ? this.baseChargeNonUsageValues(itemValue)
      : this.baseChargeUsageValues(itemValue);
  }
  baseChargeNonUsageValues(itemValue) {
    let usageValue;
    if (
      itemValue.minEnergyUsage !== 0 &&
      itemValue.maxEnergyUsage === 99999 &&
      itemValue.billCredit <= 0
    ) {
      usageValue = ` $${itemValue.billCredit} usage (<=${itemValue.minEnergyUsage})`;
    } else if (
      itemValue.minEnergyUsage !== 0 &&
      itemValue.maxEnergyUsage !== 0
    ) {
      usageValue = ` $${itemValue.billCredit} usage (${itemValue.minEnergyUsage} - ${itemValue.maxEnergyUsage})`;
    }
    return usageValue;
  }
  baseChargeUsageValues(itemValue) {
    let usageValue = '0';
    if (itemValue.usage1 != null && itemValue.usage2 === null) {
      usageValue = ` $${itemValue.usage1Charge} usage (<=${itemValue.usage1})`;
    }
    if (itemValue.usage2 != null && itemValue.usage1 != null) {
      usageValue = ` $${itemValue.usage1Charge} usage (${itemValue.usage1} - ${itemValue.usage2})`;
    }
    if (itemValue.usage3 != null && itemValue.usage4 === null) {
      usageValue = ` $${itemValue.usage1Charge} usage (${itemValue.usage1} - ${itemValue.usage2}); 
      ${itemValue.usage2Charge} usage (<=$${itemValue.usage3})`;
    }
    if (itemValue.usage3 != null && itemValue.usage4 != null) {
      usageValue = ` $${itemValue.usage1Charge} usage (${itemValue.usage1} - ${itemValue.usage2}); 
      ${itemValue.usage2Charge} usage (${itemValue.usage3} - ${itemValue.usage4})`;
    }

    return usageValue;
  }
  
  removeminus(input) {
    var str = "" + input;

    if(str !== null && str != "")
    {
      var matches = str.match(/(\d+)/);
      
      if (matches) {
          return "$"+ matches[0];
      }
   
    }

return "$" + input;
}
loadScript() {
  let node = document.createElement('script'); // creates the script tag
  node.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10999221905'; // sets the source (insert url in between quotes)
  // node.type = 'text/javascript'; // set the script type
  node.async = true; // makes script run asynchronously
  // node.charset = 'utf-8';
  // append to head of document
  
  document.getElementsByTagName('head')[0].appendChild(node); 

  let script = this._renderer2.createElement('script');
  script.setAttribute('id', 'ChatScript');
  script.text = `
      (function(d, w, c) {
        w.BrevoConversationsID = '649dacacdbc74231a94a3297';
        w[c] = w[c] || function() {
            (w[c].q = w[c].q || []).push(arguments);
        };
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
        if (d.head) d.head.appendChild(s);
    })(document, window, 'BrevoConversations');
  `;

  const existingScript = document.getElementById("ChatScript");
  if (!existingScript) {
    
  document.getElementsByTagName('head')[0].appendChild(script); 
  }
}
}
